module.exports = __webpack_public_path__ + "static/doc_canuts_en-5737bee0aa82e0cc12f1d99f3921fd52.jpg";